interface ReportWidgetLineChartActiveDotProps {
    cx?: number;
    cy?: number;
    fill?: string;
    stroke?: string;
}

function isPaintColor(color?: string): boolean {
    if (!color) {
        return false;
    }

    const normalized = color.trim().toLowerCase();
    return normalized !== 'none' && !normalized.startsWith('url(');
}

export const ReportWidgetLineChartActiveDot = ({
    cx,
    cy,
    fill,
    stroke,
}: ReportWidgetLineChartActiveDotProps) => {
    if (typeof cx !== 'number' || typeof cy !== 'number') {
        return null;
    }

    const color = isPaintColor(fill) ? fill : stroke;
    if (!isPaintColor(color)) {
        return null;
    }

    return (
        <circle
            cx={cx}
            cy={cy}
            r={5}
            style={{ fill: color, stroke: '#FFFFFF', strokeWidth: 2 }}
        />
    );
};
